<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- MODAL -->
  <div
    class="modal fade"
    id="enviar-proposta-compra-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
    @click.self="cancelModal"
    @keydown.esc="cancelModal"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body" style="padding: 0; margin: 0">
            <h4 style="margin-left: 20px; margin-top: 6px">PROPOSTA DE COMPRA</h4>
            <div class="card card-primary">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-1" v-if="lote.lote_permitir_parcelamento == 1">
                    <div class="form-group">
                      <label style="width: 100%">À VISTA:</label>
                      <input
                        style="margin-right: 10px; height: 25px; width: 25px; margin-top: 5px"
                        type="radio"
                        id="html"
                        name="forma_pagamento"
                        value="a_vista"
                        v-model="formData.forma_pagamento"
                        @change="pagamento"
                        @focus="resetarValores('a_vista')"
                      />
                    </div>
                  </div>

                  <!-- VALOR À VISTA-->
                  <div :class="lote.lote_permitir_parcelamento == 1 ? 'col-sm-11' : 'col-sm-12'">
                    <div class="form-group">
                      <label for="description" style="width: 100%">
                        VALOR À VISTA (R$)
                        <!--<span v-if="formData.valor_proposta_convertido">- R$ {{ toCurrency(formData.valor_proposta_convertido) }}</span> -->
                        <span style="float: right; color: blue" v-if="lote.lote_permitir_form_proposta_inferior == 0">
                          MÍNIMO R$ {{ toCurrency(formData.valor_minimo) }}
                        </span>
                      </label>
                      <input
                        class="form-control"
                        v-model="formData.valor_a_vista"
                        pattern="[0-9][0-9.,]*[0-9]"
                        title="Valor válido"
                        @keyup="alterarValorProposta"
                        @blur="formatarValor"
                        @focus="resetarValores('a_vista')"
                      />

                      <span
                        v-if="v$.valor_a_vista_convertido"
                        style="color: red"
                        v-for="error in v$.valor_a_vista_convertido.$errors"
                        :key="error.$uid"
                      >
                        {{ error.$message }}
                      </span>
                    </div>
                  </div>

                  <!-- PARCELADO -->
                  <div class="col-sm-1" v-if="lote.lote_permitir_parcelamento == 1">
                    <div class="form-group">
                      <label style="width: 100%">PARCELADO</label>
                      <input
                        style="margin-right: 10px; height: 25px; width: 25px; margin-top: 5px"
                        type="radio"
                        id="html"
                        name="forma_pagamento"
                        value="parcelado"
                        v-model="formData.forma_pagamento"
                        @focus="resetarValores('parcelado')"
                        @change="pagamento"
                      />
                    </div>
                  </div>

                  <!-- VALOR -->
                  <div class="col-sm-3" v-if="lote.lote_permitir_parcelamento == 1">
                    <div class="form-group">
                      <label for="description" style="width: 100%">
                        VALOR (R$)
                        <span style="float: right; color: blue" v-if="lote.lote_permitir_form_proposta_inferior == 0">
                          MÍNIMO R$ {{ toCurrency(formData.valor_minimo) }}
                        </span>
                      </label>
                      <input
                        class="form-control"
                        v-model="formData.valor"
                        pattern="[0-9][0-9.,]*[0-9]"
                        title="Valor válido"
                        @keyup="alterarValorProposta"
                        @blur="formatarValor"
                        @focus="resetarValores('parcelado')"
                      />
                      <span
                        v-if="formData.forma_pagamento == 'parcelado'"
                        style="color: red"
                        v-for="error in v$.valor_proposta_convertido.$errors"
                        :key="error.$uid"
                      >
                        {{ error.$message }}
                      </span>
                    </div>
                  </div>

                  <!-- ENTRADA -->
                  <div class="col-sm-4" v-if="lote.lote_permitir_parcelamento == 1">
                    <div class="form-group">
                      <label for="description" style="width: 100%">
                        % DE ENTRADA
                        <span style="float: right; float: right; color: blue" v-if="lote.lote_permitir_form_proposta_inferior == 0">
                          MÍNIMO {{ this.formData.lote_pct_entrada }}%
                        </span>
                      </label>
                      <div class="input-group mb-3">
                        <input
                          class="form-control"
                          v-model="formData.perc_entrada_formatado"
                          @keyup="calcularEntrada"
                          @blur="formatarEntrada()"
                          @focus="resetarValores('parcelado')"
                        />

                        <div class="input-group-append">
                          <div class="input-group-text" id="div-lock" style="background-color: white; border-left: 0px solid #000000 !important">
                            <span id="lock" class="fas fa-percent"></span>
                          </div>
                        </div>
                      </div>
                      <span
                        v-if="formData.forma_pagamento == 'parcelado'"
                        style="color: red"
                        v-for="error in v$.perc_entrada.$errors"
                        :key="error.$uid"
                      >
                        {{ error.$message }}
                      </span>
                    </div>
                  </div>

                  <!-- PARCELAS -->
                  <div class="col-sm-4" v-if="lote.lote_permitir_parcelamento == 1">
                    <div class="form-group">
                      <label for="description" style="width: 100%">
                        QTD PARCELAS
                        <!--
                        <span style="float: right">R$ {{ formData.valor_qtd_parcelas }}</span>
                        -->
                      </label>

                      <select
                        v-if="leilao.leilao_tipo == 'judicial'"
                        class="custom-select rounded-0"
                        v-model="formData.qtd_parcelas"
                        @change="calcularParcela, resetarValores('parcelado')"
                      >
                        <option v-for="parcela in parcelas" :key="parcela" :value="parcela">{{ parcela }}</option>
                      </select>

                      <input
                        v-else
                        class="form-control"
                        v-model="formData.qtd_parcelas"
                        type="number"
                        @keyup="formatarParcelas()"
                        @blur="calcularParcela, (formData.forma_pagamento = 'parcelado')"
                        @focus="resetarValores('parcelado')"
                      />

                      <span
                        v-if="formData.forma_pagamento == 'parcelado'"
                        style="color: red"
                        v-for="error in v$.qtd_parcelas.$errors"
                        :key="error.$uid"
                      >
                        {{ error.$message }}
                      </span>
                    </div>
                  </div>

                  <!-- INDICE -->
                  <div class="col-sm-12" v-if="lote.lote_permitir_parcelamento == 1 && leilao.leilao_tipo == 'judicial'">
                    <div class="form-group">
                      <label for="description">ÍNDICE DE CORREÇÃO</label>
                      <input class="form-control" v-model="formData.indice" disabled />
                    </div>
                  </div>

                  <!-- CONDIÇÃO DE PAGAMENTO -->
                  <div class="col-sm-12" v-if="formData.leilao_tipo == 'extra'">
                    <label for="nome" style="margin-bottom: 0px">CONDIÇÃO DE PAGAMENTO:</label>

                    <textarea
                      id="justificativa"
                      name="justificativa"
                      rows="4"
                      cols="50"
                      class="form-control"
                      style="width: 100%"
                      v-model="formData.observacoes"
                    ></textarea>

                    <span style="color: red" v-for="error in v$.observacoes.$errors" :key="error.$uid">
                      {{ error.$message }}
                    </span>
                  </div>
                </div>

                <p>Pedimos a gentileza de assinar a proposta e nos devolver via e-mail.</p>

                <span>Comissão: {{ toCurrency(lote.lote_comissao) }}%</span>
                <br />
                <span>ICMS: {{ toCurrency(lote.lote_icms) }}%</span>
                <br />
                <span>Taxa administrativa: R${{ toCurrency(leilao.leilao_taxa_administrativa) }}</span>
                <br />
              </div>

              <!--<div v-html="corpo_email"></div>-->

              <div class="card-footer">
                <button data-toggle="modal" class="btn btn-success" @click="validate">Enviar proposta</button>
                <button
                  style="margin-left: 15px"
                  id="fechar_enviar_proposta_compra"
                  class="btn btn-danger"
                  type="button"
                  data-dismiss="modal"
                  @click="this.setEnviarPropostaCompra(false)"
                >
                  Fechar
                </button>
                <button
                  hidden
                  style="margin-left: 15px"
                  data-toggle="modal"
                  id="open_modal"
                  data-target="#enviar-proposta-compra-modal"
                  class="btn btn-danger"
                >
                  open_modal
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import auxFormatacao from "../controller/auxFormatacao.js";
import auxFormatarEmail from "../controller/auxFormatarEmail.js";
import sweetAlert from "../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import currencyController from "../controller/currencyController.js";
import { helpers } from "@vuelidate/validators";

import useVueLidate from "@vuelidate/core";
import { required } from "../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  props: ["user", "lote", "leilao", "setEnviarPropostaCompra", "propostaEnviada", "propostas"],

  mixins: [sweetAlert, Swal, AuxController, currencyController, auxFormatarEmail, auxFormatacao],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      tests: [],
      acao: "",
      titulo_btn: "",
      titulo_modal: "",
      selected_task: "",
      audios: [],
      textos: [],
      contatos: [],
      parcelas: [],
      pracas: [],
      a_vista: false,
      parcelado: false,
      corpo_email: "",
      valor_entrada: "",
      valor_proposta: "",
      pct_entrada: "",
    };
  },

  setup() {
    const formData = reactive({
      max_parcelas: "",
      nome_campanha: "",
      audio_id: "",
      texto_id: "",
      contato_id: "",
      praca: "",
      valor: "",
      perc_entrada: "",
      valor_perc_entrada: "",
      observacoes: "",
      qtd_parcelas: "",
      valor_qtd_parcelas: "",
      indice: "",
      data_leilao: "",
      valor_proposta_convertido: "",
      valor_a_vista: "",
      valor_a_vista_convertido: "",
      a_vista: false,
      parcelado: false,
      valor_minimo: "",
      forma_pagamento: "",
      perc_entrada_formatado: "",
      praca_atual: "",
      lote_permitir_form_proposta_inferior: "",
      leilao_tipo: "",
      leilao_1_modalidade: "",
    });

    const rules = computed(() => {
      let local_rules = {
        forma_pagamento: { required },
      };

      if (formData.leilao_tipo == "extra" && formData.leilao_1_modalidade == "venda") {
        local_rules.observacoes = { required };
      }

      if (formData.forma_pagamento == "a_vista") {
        local_rules.valor_a_vista_convertido = {
          required,
          validarMinimo: helpers.withMessage(" O valor da proposta precisar ser maior ou igual ao mínimo.", validarMinimo),
          validarMaximo: helpers.withMessage(" O valor da proposta precisar ser menor que 9.999.999.999.", validarMaximo),
        };
      }

      if (formData.forma_pagamento == "parcelado" && formData.leilao_tipo == "judicial") {
        local_rules.qtd_parcelas = {
          required,
          validarParcelas: helpers.withMessage(" A quantidade de parcelas precisa ser entre 1 e " + formData.max_parcelas, validarParcelas),
        };
      }

      if (formData.forma_pagamento == "parcelado" && formData.leilao_tipo == "extra") {
        local_rules.qtd_parcelas = {
          required,
          validarParcelasSemMinimo: helpers.withMessage(" A quantidade de parcelas precisa ser maior que zero.", validarParcelasSemMinimo),
        };
      }

      if (formData.forma_pagamento == "parcelado") {
        local_rules.perc_entrada = {
          required,
          validarMaximo: helpers.withMessage(" O valor de entrada deve ser maior ou igual ao mínimo.", validarEntradaMinimo),
          validarMinimo: helpers.withMessage(" O valor máximo de entrada é 90%.", validarEntradaMaximo),
        };
        local_rules.indice = { required };
        local_rules.data_leilao = { required };
        local_rules.valor_proposta_convertido = {
          required,
          validarMinimo: helpers.withMessage(" O valor da proposta precisar ser maior ou igual ao mínimo.", validarMinimo),
          validarMaximo: helpers.withMessage(" O valor da proposta precisar ser menor que 9.999.999.999.", validarMaximo),
        };
      }

      return local_rules;
    });

    const validarParcelas = (valor) => {
      if (!valor || Number(valor) > 30 || Number(valor) <= 0) {
        return false;
      } else {
        return true;
      }
    };

    const validarParcelasSemMinimo = (valor) => {
      if (!valor || Number(valor) <= 0) {
        return false;
      } else {
        return true;
      }
    };

    const validarMaximo = (valor) => {
      if (valor && valor > 9999999999) {
        return false;
      } else {
        return true;
      }
    };

    const validarMinimo = (valor) => {
      if ((!valor || valor < formData.valor_minimo) && formData.lote_permitir_form_proposta_inferior == 0) {
        return false;
      } else {
        return true;
      }
    };

    const validarEntradaMinimo = (valor) => {
      if (!valor || valor < 0 || (valor < formData.lote_pct_entrada && !formData.lote_permitir_form_proposta_inferior)) {
        return false;
      } else {
        return true;
      }
    };

    const validarEntradaMaximo = (valor) => {
      if (valor > 90) {
        return false;
      } else {
        return true;
      }
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log("Create test");
    console.log(this.lote);

    if (this.leilao.leilao_1_modalidade == "venda") {
      this.formData.lote_permitir_form_proposta_inferior = this.lote.lote_permitir_form_proposta_inferior;
    } else {
      this.formData.lote_permitir_form_proposta_inferior = 0;
    }

    this.isLogged(() => {
      let btn = document.getElementById("open_modal");

      btn.click();

      //PRAÇA ATUAL
      if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
        this.praca_atual = 1;
      } else if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
        this.praca_atual = 2;
      } else if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
        this.praca_atual = 3;
      } else if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
        this.praca_atual = 4;
      }

      this.formData.valor_minimo = this.getValorAtual(this.lote);

      //ENTRADA
      this.formData.perc_entrada = 0;
      this.formData.valor_perc_entrada = 0;

      //ENTRADA MÍNIMA
      this.formData.lote_pct_entrada = this.lote.lote_pct_entrada;

      //PARCELAS

      for (let i = 0; i < this.lote.lote_max_parcelas; i++) {
        this.parcelas.push(i + 1);
      }

      this.formData.max_parcelas = this.lote.lote_max_parcelas;
      //this.formData.qtd_parcelas = this.lote.lote_max_parcelas;
      this.formData.valor_qtd_parcelas = this.toCurrency(this.formData.valor / this.formData.qtd_parcelas);

      this.formData.indice = this.lote.lote_indice_correcao;
      this.formData.leilao_tipo = this.leilao.leilao_tipo;
      this.formData.leilao_1_modalidade = this.leilao.leilao_1_modalidade;

      if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
        this.formData.data_leilao = this.leilao.leilao_1_data;

        this.pracas.push({ nome: "1º praça", value: 1 });
      }
      if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
        this.formData.data_leilao = this.leilao.leilao_2_data;

        this.pracas.push({ nome: "2º praça", value: 2 });
      }
      if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
        this.formData.data_leilao = this.leilao.leilao_3_data;

        this.pracas.push({ nome: "3º praça", value: 3 });
      }
      if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
        this.formData.data_leilao = this.leilao.leilao_4_data;

        this.pracas.push({ nome: "4º praça", value: 4 });
      }

      this.formData.praca = this.pracas[0].value;

      console.log("Praças");
      console.log(this.pracas);

      this.alterarValorProposta();
    });
  },

  methods: {
    resetarValores(forma_pagamento) {
      this.formData.forma_pagamento = forma_pagamento;

      if (forma_pagamento == "a_vista") {
        this.formData.valor = null;
        this.formData.perc_entrada_formatado = null;
        this.formData.perc_entrada = null;
        this.formData.qtd_parcelas = null;
      }
      if (forma_pagamento == "parcelado") {
        this.formData.valor_a_vista = null;
      }
    },

    formatarParcelas() {
      this.formData.qtd_parcelas = this.formData.qtd_parcelas.replace(/[^0-9]/g, "");
    },

    getValorAtual(lote) {
      if (this.praca_atual == 1) {
        return lote.lote_valor_1;
      } else if (this.praca_atual == 2) {
        return lote.lote_valor_2;
      } else if (this.praca_atual == 3) {
        return lote.lote_valor_3;
      } else if (this.praca_atual == 4) {
        return lote.lote_valor_4;
      }
    },

    pagamento() {
      console.log("Pagamento");
      console.log(this.formData.forma_pagamento);
    },

    changeAVista() {
      console.log("Change a vista");

      this.formData.a_vista = true;
      this.parcelado = false;
      this.formData.parcelado = false;

      console.log(this.formData.a_vista);
      console.log(this.formData.parcelado);
    },

    changeParcelado() {
      this.formData.parcelado = true;
      this.a_vista = false;
      this.formData.a_vista = false;

      console.log("Change parcelado");
      console.log(this.formData.a_vista);
      console.log(this.formData.parcelado);
    },

    isLogged(callback) {
      let data = {
        lote_id: this.lote.id,
        leilao_id: this.leilao.id,
      };

      axios
        .post(`/user/proposta/check`, data)
        .then((response) => {
          if (response.data.success) {
            callback();
          } else {
            this.isLoading = false;
            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/lote/" + this.lote.id);
            this.setEnviarPropostaCompra(false, true);
          }
        })
        .catch((error) => {
          console.log(error);

          if (typeof error == "object") {
            if (error.response.status == "403") {
              this.showErrorMessageWithButtonAndRedirectIfConfirm(
                "Ops...",
                "Para enviar proposta de compra você precisa estar logado. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
            } else {
              this.showErrorMessageWithButtonAndRedirectIfConfirm(
                "Ops...",
                "Para enviar proposta de compra você precisa estar logado. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
            }
          } else {
            this.showErrorMessageWithButtonAndReloadIfConfirm("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
          }

          this.setEnviarPropostaCompra(false, true);
        });
    },

    alterarPraca() {
      /*
      console.log("Praça alterada");

      console.log(this.lote);

      if (this.formData.praca == 1) {
        this.formData.valor = this.toCurrency(this.lote.lote_avaliacao);
      } else if (this.formData.praca == 2) {
        this.formData.valor = this.toCurrency(this.lote.lote_valor_2);
      } else if (this.formData.praca == 3) {
        this.formData.valor = this.toCurrency(this.lote.lote_valor_3);
      } else if (this.formData.praca == 4) {
        this.formData.valor = this.toCurrency(this.lote.lote_valor_4);
      }

      console.log("Valor");
      console.log(this.formData.valor);
      console.log(this.formData.praca);

      this.alterarValorProposta();
      */

      this.formData.valor = this.lote.lote_avaliacao;
      this.alterarValorProposta();
    },

    alterarValorProposta() {
      this.formData.valor_proposta_convertido = Number(this.toNumber(this.formData.valor));
      this.formData.valor_a_vista_convertido = Number(this.toNumber(this.formData.valor_a_vista));

      this.calcularEntrada();
    },

    formatarValor() {
      if (this.formData.valor_proposta_convertido > 0) {
        this.formData.valor = this.toCurrency(this.formData.valor_proposta_convertido);
      }

      if (this.formData.valor_a_vista_convertido > 0) {
        this.formData.valor_a_vista = this.toCurrency(this.formData.valor_a_vista_convertido);
      }
    },

    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },

    calcularEntrada() {
      /*
      console.log(typeof this.formData.valor_proposta_convertido);
      console.log(this.formData.perc_entrada);
      console.log(this.formData.valor_proposta_convertido);
      console.log((this.formData.perc_entrada * this.formData.valor_proposta_convertido) / 100);
      */
      this.formData.perc_entrada = Number(this.toNumber(this.formData.perc_entrada_formatado));

      this.calcularParcela();
      this.formData.valor_perc_entrada = (this.formData.perc_entrada * this.formData.valor_proposta_convertido) / 100;
    },

    formatarEntrada() {
      this.formData.perc_entrada_formatado = this.toCurrency(this.formData.perc_entrada_formatado);
    },

    calcularParcela() {
      console.log("Calculando parcelas");

      let valor_entrada = (this.formData.perc_entrada * this.formData.valor_proposta_convertido) / 100;

      this.formData.valor_qtd_parcelas = this.toCurrency((this.formData.valor_proposta_convertido - valor_entrada) / this.formData.qtd_parcelas);
      console.log(this.formData.valor_qtd_parcelas);
    },

    cancelModal() {
      this.setEnviarPropostaCompra(false);
    },

    async validate() {
      const result = await this.v$.$validate();

      if (!this.formData.forma_pagamento) {
        this.showErrorMessageWithButton("Ops...", "Selecione a forma de pagamento");
      } else {
        if (result) {
          this.store();
        } else {
          console.log(this.v$);
        }
      }
    },

    store() {
      this.isLoading = true;

      let tipo = "venda";
      //let tipo = this.formData.forma_pagamento == "a_vista" ? "venda" : "parcelamento";

      this.valor_proposta =
        this.formData.forma_pagamento == "a_vista" ? Number(this.toNumber(this.formData.valor_a_vista)) : Number(this.toNumber(this.formData.valor));

      this.pct_entrada = this.formData.forma_pagamento == "a_vista" ? 100 : this.formData.perc_entrada;
      this.parcelas = this.formData.forma_pagamento == "a_vista" ? 0 : this.formData.qtd_parcelas;
      this.valor_entrada = this.formData.forma_pagamento == "a_vista" ? 0 : this.formData.valor_perc_entrada;

      if (this.formData.forma_pagamento == "a_vista") {
        this.corpo_email = this.formatarEmail();
      } else {
        this.corpo_email = this.formatarEmailParcelado();
      }

      if (this.corpo_email) {
        let data = {
          praca: this.formData.praca,
          valor_bem: this.getValorAtual(this.lote),
          valor_proposta: this.valor_proposta,
          valor_entrada: this.valor_entrada,
          pct_entrada: this.pct_entrada,
          observacao: this.formData.observacoes,
          tipo: tipo,
          lote_id: this.lote.id,
          leilao_id: this.leilao.id,
          indice: this.lote.lote_indice_correcao,
          parcelas: this.parcelas,
          data_leilao: this.formData.data_leilao,
          corpo_email: this.corpo_email,
        };

        console.log("Cadastrando proposta compra");
        console.log(data);

        axios
          .post(`/proposta/store`, data)
          .then((response) => {
            this.isLoading = false;

            if (response.data.success) {
              if (this.leilao.leilao_tipo == "extra") {
                this.showSuccessMessageWithButtonAndReload(
                  "Proposta enviada com sucesso!",
                  "Atenção! A presente proposta deverá ser assinada e encaminhada no e-mail: documentos@rochaleiloes.com.br, após, será encaminhada ao vendedor para análise, uma vez aprovada, o proponente deverá honrar os termos da proposta, sob pena de ser considerado inadimplente, com o devido bloqueio no presente site."
                );
              } else if (this.leilao.leilao_tipo == "judicial") {
                this.showSuccessMessageWithButtonAndReload(
                  "Proposta enviada com sucesso!",
                  "Atenção! A presente proposta deverá ser assinada e encaminhada no e-mail: documentos@rochaleiloes.com.br, após, será acostada aos autos para análise conforme previsão em Edital, uma vez aprovada, o proponente deverá honrar os termos da proposta, sob pena de ser considerado inadimplente, com o devido bloqueio no presente site."
                );
              }
              this.setEnviarPropostaCompra();
            } else {
              this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/lote/" + this.lote.id);
            }
          })
          .catch((error) => {
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      }
    },

    formatarEmail() {
      try {
        this.corpo_email = false;

        this.proposta_formatada = {
          lote_titulo: this.lote.lote_titulo,
          lote_numero: this.lote.lote_numero,
          leilao_id: this.leilao.id,
        };

        if (this.lote.processo) {
          if (this.lote.processo.processo_vara) {
            this.proposta_formatada.processo_vara = this.lote.processo.processo_vara;
          } else {
            this.proposta_formatada.processo_vara = "";
          }

          if (this.lote.processo.cidade) {
            this.proposta_formatada.cidade_processo = this.lote.processo.cidade;
          } else {
            this.lote.processo.cidade = "";
          }

          if (this.lote.processo.estado) {
            this.proposta_formatada.estado_processo_sigla = this.lote.processo.estado.sigla;
          } else {
            this.proposta_formatada.estado_processo_sigla = "";
          }
        }

        let corpo =
          '<div style="color:black">' +
          "<p><b>DATA DA PROPOSTA: </b> " +
          this.formatDate(new Date()) +
          "<br/></p>" +
          "<p><b>AUTOS: </b> AUTOS <br/></p>" +
          "<p><b>VARA/CIDADE: </b> " +
          this.proposta_formatada.processo_vara +
          "<br/></p>" +
          "<p><b>DATA LEILÃO: </b> " +
          this.formatDate(this.formData.data_leilao) +
          "<br/></p>" +
          "<p><b>PRAÇA: </b> " +
          this.formData.praca +
          "º PRAÇA<br/></p>" +
          "<p><b>DESCRIÇÃO DO BEM: </b> " +
          this.formatarHTML(this.lote.lote_descricao) +
          "<br/></p>" +
          "<p><b>VALOR DO BEM EM LEILÃO: </b> R$" +
          this.toCurrency(this.lote.lote_avaliacao) +
          "<br/></p>" +
          "<p><b>VALOR DA PROPOSTA: </b> R$" +
          this.toCurrency(Number(this.toNumber(this.valor_proposta))) +
          "<br/></p>" +
          "<p><b>COMISSÃO DO LEILOEIRO: </b> " +
          this.formatarComissao(this.lote.lote_comissao) +
          "%" +
          "<br/>" +
          "<p><b>PROPONENTE: </b> " +
          this.getProponente() +
          "<br/></p>" +
          "<p><b>ENDEREÇO: </b> " +
          this.getEndereco() +
          "<br/></p>" +
          "<p><b>CONTATO: </b> " +
          (this.user.profile.telefone_fixo ? this.user.profile.telefone_fixo : "") +
          " - " +
          this.user.profile.telefone_celular +
          "<br/></p>" +
          "<p><b>E-MAIL: </b> " +
          this.user.email +
          "<br/></p>" +
          "</div>";

        corpo = this.formatarVariaveisEmail(corpo, this.lote.id, this.lote.leilao_id);

        return corpo;
      } catch (error) {
        console.log(error);

        return false;
      }
    },

    formatarEmailParcelado() {
      try {
        this.corpo_email = false;

        this.proposta_formatada = {
          lote_titulo: this.lote.lote_titulo,
          lote_numero: this.lote.lote_numero,
          leilao_id: this.leilao.id,
        };

        if (this.lote.processo) {
          if (this.lote.processo.processo_vara) {
            this.proposta_formatada.processo_vara = this.lote.processo.processo_vara;
          } else {
            this.proposta_formatada.processo_vara = "";
          }

          if (this.lote.processo.cidade) {
            this.proposta_formatada.cidade_processo = this.lote.processo.cidade;
          } else {
            this.lote.processo.cidade = "";
          }

          if (this.lote.processo.estado) {
            this.proposta_formatada.estado_processo_sigla = this.lote.processo.estado.sigla;
          } else {
            this.proposta_formatada.estado_processo_sigla = "";
          }
        }

        let corpo =
          '<div style="color:black">' +
          "<p><b>DATA DA PROPOSTA: </b> " +
          this.formatDate(new Date()) +
          "<br/></p>" +
          "<p><b>AUTOS: </b> AUTOS <br/></p>" +
          "<p><b>VARA/CIDADE: </b> " +
          this.proposta_formatada.processo_vara +
          "<br/></p>" +
          "<p><b>DATA LEILÃO: </b> " +
          this.formatDate(this.formData.data_leilao) +
          "<br/></p>" +
          "<p><b>PRAÇA: </b> " +
          this.formData.praca +
          "º PRAÇA<br/></p>" +
          "<p><b>DESCRIÇÃO DO BEM: </b> " +
          this.formatarHTML(this.lote.lote_descricao) +
          "<br/></p>" +
          "<p><b>VALOR DO BEM EM LEILÃO: </b> R$" +
          this.toCurrency(this.lote.lote_avaliacao) +
          "<br/></p>" +
          "<p><b>VALOR DA PROPOSTA: </b> R$" +
          this.toCurrency(Number(this.toNumber(this.formData.valor))) +
          "<br/></p>" +
          "<p><b>% DE ENTRADA: </b> " +
          this.formatarComissao(this.formData.perc_entrada.toString()) +
          "% (R$" +
          this.toCurrency(this.formData.valor_perc_entrada) +
          ") <br/></p>" +
          "<p><b>QTD PARCELAS: </b> " +
          this.formData.qtd_parcelas +
          "x <br/></p>" +
          "<p><b>VALOR DA PARCELA: </b> R$" +
          this.calcularParcela2(this.formData.valor, this.formData.valor_perc_entrada, this.formData.qtd_parcelas) +
          "<br/></p>" +
          "<p><b>COMISSÃO DO LEILOEIRO: </b> " +
          this.formatarComissao(this.lote.lote_comissao) +
          "%" +
          "<br/></p>" +
          "<p><b>INDICE DE CORREÇÃO: </b> " +
          this.lote.lote_indice_correcao +
          "<br/></p>" +
          "<p><b>PROPONENTE: </b> " +
          this.getProponente() +
          "<br/></p>" +
          "<p><b>ENDEREÇO: </b> " +
          this.getEndereco() +
          "<br/></p>" +
          "<p><b>CONTATO: </b> " +
          (this.user.profile.telefone_fixo ? this.user.profile.telefone_fixo : "") +
          " - " +
          this.user.profile.telefone_celular +
          "<br/></p>" +
          "<p><b>E-MAIL: </b> " +
          this.user.email +
          "<br/></p>" +
          "</div>";

        corpo = this.formatarVariaveisEmail(corpo, this.lote.id, this.lote.leilao_id);

        return corpo;
      } catch (error) {
        console.log(error);

        return false;
      }
    },

    getEndereco() {
      let endereco =
        this.user.profile.endereco +
        " - " +
        this.user.profile.endereco_num +
        " - " +
        this.user.profile.endereco_bairro +
        " - CEP: " +
        this.user.profile.endereco_cep +
        " - " +
        this.user.profile.cidade.nome +
        "/" +
        this.user.profile.estado.nome;
      return endereco;
    },

    getProponente() {
      let proponente =
        this.user.profile.nome_completo +
        " - " +
        this.user.profile.profissao +
        " - " +
        this.getEstadoCivil() +
        " - CPF: " +
        this.user.profile.cpf +
        " - RG: " +
        this.user.profile.rg;
      return proponente;
    },

    getEstadoCivil() {
      let estado_civil = this.user.profile.estado_civil;

      if (estado_civil == "divorciado") {
        return "divorciado";
      }

      if (estado_civil == "separado_judicialmente") {
        return "Separado judicialmente";
      }

      if (estado_civil == "casado") {
        return "Casado";
      }

      if (estado_civil == "viuvo") {
        return "Viuvo";
      }

      if (estado_civil == "solteiro") {
        return "Solteiro";
      }
      if (estado_civil == "solteiro_com_uniao_estavel") {
        return "Solteiro com união estável";
      }
      if (estado_civil == "solteiro_sem_uniao_estavel") {
        return "Solteiro sem união estável";
      }
      if (estado_civil == "uniao_estavel") {
        return "União estável";
      }
    },

    calcularParcela2(valor_proposta, valor_entrada, parcelas) {
      valor_proposta = Number(this.toNumber(valor_proposta));

      console.log("Calculando");
      console.log(valor_proposta);
      console.log(valor_entrada);

      return this.toCurrency((valor_proposta - valor_entrada) / parcelas);
    },

    formatarHTML(valor) {
      if (typeof valor == "string" && valor.includes("</")) {
        console.log("Entrou no IF");
        var div = document.createElement("div");
        div.innerHTML = valor;
        valor = div.textContent || div.innerText || "";
      }
      console.log("Valor depois");
      console.log(valor);

      return valor;
    },

    formatarComissao(texto) {
      if (typeof texto == "number") {
        return texto + ",00";
      } else {
        if (texto) {
          return this.replaceAll(texto, ".", ",");
        } else {
          return texto;
        }
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.current-page {
  background-color: #428bca !important;
  color: white;
}

.modal-content {
  width: 1500px;
  margin-left: -430px;
}

@media screen and (max-width: 1600px) {
  .modal-content {
    width: 1350px;
    margin-left: -400px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1350px) {
  .modal-content {
    width: 1250px;
    margin-left: -350px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1100px;
    margin-left: -280px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 1000px;
    margin-left: -240px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
    min-width: 400px;
  }
}
</style>
